export const DISPATCH_OWNED_RUNTIME_MODE = "dispatch-owned-runtime" as const;
export const OPENMELD_DISPATCH_RUNTIME_MODE_ENV =
  "OPENMELD_DISPATCH_RUNTIME_MODE";
export const OPENMELD_DISPATCH_RUNTIME_DISPATCH_ID_ENV =
  "OPENMELD_DISPATCH_RUNTIME_DISPATCH_ID";
export const OPENMELD_DISPATCH_RUNTIME_TARGET_PROFILE_ID_ENV =
  "OPENMELD_DISPATCH_RUNTIME_TARGET_PROFILE_ID";
export const OPENMELD_USER_FACING_CLI_COMMAND_ENV =
  "OPENMELD_USER_FACING_CLI_COMMAND";
export const OPENMELD_SPACE_ACTION_TOOL_COMMAND_PATH_ENV =
  "OPENMELD_SPACE_ACTION_TOOL_COMMAND_PATH";
export const DISPATCH_SPACE_ACTION_CLI_FALLBACK_COMMAND = `"$${OPENMELD_SPACE_ACTION_TOOL_COMMAND_PATH_ENV}"`;
